import request from '@/api/request'


// 学习-我的课程-模块课程(购买过的课程)
export function findByModuleOfCourses() {
	return request({
		url: '/api/api/myStudent/findByModuleOfCourses',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 学习-我的课程-模块课程详情(购买过的课程)
export function findByModuleOfCoursesDetail(data) {
	return request({
		url: '/api/api/myStudent/findByModuleOfCoursesDetail?courseId=' + data.courseid,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 我的班级,系列课程列表
export function getMyCourse() {
	return request({
		// url: '/api/courseapi/myCourse',
		url: '/api/api/myStudent/findBySeriesOfCourses',
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 我的班级,获取系列课程列表某个班的课
export function findBySeriesOfCoursesDetail(data) {
	return request({
		url: '/api/api/myStudent/findBySeriesOfCoursesDetail?classesId=' + data.classesId + '&classesTypeId=' +
			data.classesTypeId,
		method: 'get',
		data: data,
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 我的班级
export function getCourseDetails(data) {
	if (data.classid == undefined) {
		return request({
			url: `/api/courseapi/queryCourseDetails?courseid=${data.courseid}&uid=${data.uid}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json",
				"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') :
					''
			},
		})
	} else {
		return request({
			url: `/api/courseapi/queryCourseDetails?classid=${data.classid}&courseid=${data.courseid}&uid=${data.uid}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json",
				"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') :
					''
			},
		})
	}

}

// 上次学习
export function getCurrentChapter(classid) {
	return request({
		url: `/api/courseapi/queryCurrentChapter?classid=${classid}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 学习计划
export function getStudyPlan(classid) {
	return request({
		url: `/api/courseapi/studyPlan?id=${classid}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 根据班级查询课堂笔记
export function getClassesNotes(classid, categoryId) {
	return request({
		url: `/api/wdClass/wdClassesNotes/wdClassesNotes/findByClasses?classesId=${classid}&categoryId=${categoryId}&pageNo=1&pageSize=9999`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 根据笔记ID查询笔记详情(此时会记录当前用户查看过)
export function findByNotesId(data) {
	return request({
		url: `/api/wdClass/wdClassesNotes/wdClassesNotes/findByNotesId?classesId=${data.classesId}&notesId=${data.notesId}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 根据班级查询课堂笔记分类
export function getNotesCategory(classid) {
	return request({
		url: `/api/wdClass/wdClassesNotes/wdClassesNotes/getNotesCategory?classesId=${classid}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 添加学习记录
export function addLearn(data) {
	return request({
		url: '/api/courseapi/addLearn',
		method: 'post',
		data: data,
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}

// 用户关联课程时间和直播的时间或次数
export function addCourseRecord(data) {
	return request({
		url: '/api/course/wdCourseRecord/save',
		method: 'post',
		data: data,
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}


// 修改当前协议是否观看
export function findAgreement(data) {
	return request({
		url: `/api/student/wdStudentAgreement/findAgreement?classid=${data.classid}`,
		method: 'get',
		headers: {
			"Content-Type": "application/json",
			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
		},
	})
}
// 用户关联课程时间和直播的时间或次数[新]
// export function addCourseRecord(data) {
// 	return request({
// 		url: '/api/course/wdCourseRecord/saveRecord ',
// 		method: 'post',
// 		data: data,
// 		headers: {
// 			"Content-Type": "application/json",
// 			"X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
// 		},
// 	})
// }

// // 视频百分比
// export function queryCourseDetails(data) {
//   return request({
//     url: '/api/courseapi/queryCourseDetails',
//     method: 'get',
//     headers: {
//       "Content-Type": "application/json",
//       "X-Access-Token": window.localStorage.getItem('token') ? window.localStorage.getItem('token') : ''
//     },
//   })
// }


// WEBPACK FOOTER //
// ./src/api/learn.js